import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c6-six-five-two',
  templateUrl: './c6-six-five-two.component.html',
  styleUrls: ['./c6-six-five-two.component.scss']
})
export class C6SixFiveTwoComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion-6/IQAC MEETINGS.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
